
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditWheel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InputWheel"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editWheel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"payload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payload"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rimData"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rimVehicleType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rimQuantity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rimOffset"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rimDiameter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rimWidth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rimHoleNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rimHolesSpacing"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rimCentrebore"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rimMaterial"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"tireData"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tireVehicleType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tireQuantity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tireType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tireDiameter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tireWidth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tireAspectRatio"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":350}};
    doc.loc.source = {"body":"mutation EditWheel($payload: InputWheel!) {\n\teditWheel(payload: $payload) {\n\t\trimData {\n\t\t\trimVehicleType\n\t\t\trimQuantity\n\t\t\trimOffset\n\t\t\trimDiameter\n\t\t\trimWidth\n\t\t\trimHoleNumber\n\t\t\trimHolesSpacing\n\t\t\trimCentrebore\n\t\t\trimMaterial\n\t\t}\n\t\ttireData {\n\t\t\ttireVehicleType\n\t\t\ttireQuantity\n\t\t\ttireType\n\t\t\ttireDiameter\n\t\t\ttireWidth\n\t\t\ttireAspectRatio\n\t\t}\n\t}\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["EditWheel"] = oneQuery(doc, "EditWheel");
        
